import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  
  {
    path: '/',
    name: 'Layout',
    redirect: '/resources',
    component: () => import('../layout/index.vue'),
    children:[
      {
        path: '/login',
        name: 'Login',
        component: () => import('../views/login.vue'),
        meta: {
          title: '登录'
        }
      },
      {
        path: '/root',
        name: 'Home',
        component:() => import('../views/Home.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/resources',
        name: 'resources',
        component: () => import('../views/resources/index.vue'),
        meta: {
          title: '虚拟云标本'
        }
      },
      {
        path: '/experiments',
        name: 'experiments',
        component: () => import('../views/experiments/index.vue'),
        meta: {
          title: '仿真实训'
        }
      },
      {
        path: '/courses',
        name: 'courses',
        component: () => import('../views/courses/index.vue'),
        meta: {
          title: '智慧课本'
        }
      },
    ]
  },
  {
    path: '/resource',
    name: 'resource',
    component: () => import('../views/view/resource.vue'),
    meta: {
      title: '云标本'
    }
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/view/course.vue'),
    meta: {
      title: '智慧课本'
    }
  },
  {
    path: '/experiment',
    name: 'experiment',
    component: () => import('../views/view/experiment.vue'),
    meta: {
      title: '云实验'
    }
  },
  {
    path: '/loginCheck',
    name: 'loginCheck',
    component: () => import('../pages/loginCheck.vue'),
    meta: {
      title: '登录验证'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {//如果设置标题，拦截后设置标题
    document.title = to.meta.title + ' - 虚拟云教具实训平台 - 十一维度教育出品'
  }
  if(to.fullPath === '/resources' && !to.query) {
    to.query.category = 0
  }
  next()
})

export default router
